import { Injectable } from "@angular/core";
@Injectable({
  providedIn: 'root',
})
export class TranslationService {
  public languages = ['he', 'eng']

  public language = 'he'

  private dictionary: { [key: string]: TranslationSet1 } = {
    he: {
      languange: 'he',
      values: {
        example: 'Beispiel',
        username: 'שם משתמש',
        Password: 'סיסמא',
        loginUser: 'כניסת משתמש',
        The_username_or_password_is_incorrect: 'שם משתמש או סיסמא לא נכונים',
        virtualLabelsApp: 'מדבקות וירטואליות',
        Name: 'שם',
        StartDate: 'תאריך התחלה',
        EndDate: 'תאריך סיום',
        ActiveLabelsSets: 'סטים פעילים', 
        Users: 'משתמשים',
        AuthenticatedUser: 'משתמש',
        Ltd: 'בע"ם',
        LabelsSets: 'סטים',
        CompaniesList: 'רשימת חברות',
        FilterByName: 'חיפוש לפי שם',
        Loading: 'טוען',
        FilterByComments: 'חיפוש לפי הערות סט',
        ID: '#',
        Active: 'פעיל',
        ProfileName: 'שם פרופיל',
        CreatedDate: 'תאריך הקמה',
        LastUpdate: 'עדכון אחרון',
        Comments: 'הערות',
        TotalLabels: 'סה"כ מדבקות',
        UsedLabels: 'נוצלו',
        Cancel: 'בטל',
        AttachLabel: 'שיוך מדבקה',
        Set: 'בחר',
        Tickets: 'כרטיסים',
        Attach: 'שייך',
        Thanks: 'תודה!',
        LabelAttached: 'שיוך מדבקה עבר בהצלחה',
        Date: 'תאריך',
        LPRNumber: 'מספר רכב',
        LPRNumber2: 'מספר רכב שני',
        OK: 'אשר',
        Continue:'המשך',
        Thisticketisvirtuallabeled: 'לכרטיס זה כבר שויכה מדבקה',
        Noavaillabelsfoundforthelabelset: 'כל המדבקות בסט הנבחר נוצלו',
        Labelsetisnotvalid: 'סט מדבקות נבחר אינו פעיל',
        Companyisnotvalid: 'החברה אינה פעילה',
        CreateUser: 'משתמש חדש',
        Role: 'הרשאה',
        Delete: 'ביטול',
        CreateLabelSet: 'סט מדבקות חדש',
        NewUser: 'משתמש חדש',
        EditUser: 'עריכת משתמש',
        CreateLabelsSetFor: 'סט מדבקות עבור ',
        AreYouSure: 'האם להמשיך? ',
        LabelProfile: 'פרופיל מדבקות',
        LabelsAmount: 'כמות מדבקות',
        TicketNumber: 'כרטיס כניסה',
        LabelsReport: 'דוח מדבקות',
        SetComments: 'הערות סט', 
        SetID: 'מספר סט',
        CompanyName: 'שם חברה',
        CreatedByUser: 'הוקם ע"י משתמש',
        Deleted: 'מבוטל',
        Attached: 'שיוך לכרטיס',
        AttachedByUser: 'שויך ע"י משתמש',
        EntryTicketIssueDate: 'תאריך כרטיס',
        PaymentDate: 'תאריך קבלה',
        ExitDate: 'תאריך יציאה',
        PaidSum: 'שולם',
        FullPriceBeforeBenefit: 'מחיר לפני הנחה',
        BenefitSum: 'סכום הנחה',
        Companies: 'חברות',
        LogOut: 'יציאה',
        Management: 'ניהול',
        SystemConfiguration: 'הגדרות מערכת',
        Sites: 'חניונים',
        EntryTicket: 'כרטיס כניסה',
        GotIt: 'מעולה',
        Billing: 'חשבון',
        Notifications: 'הודעות',
        Address: 'כתובת',
        IpAddress: 'כתובת IP',
        Center: 'מרכז',
        NoLabelsToAttach: 'לא הוגדרו מדבקות עבור משתמש זה...',
        SearchAgain: 'חפש שוב',
        TicketNotFound: 'לא נמצאו כרטיסים',
        Restore: 'שחזר',
        requestNewFeature:'אשמח אם תוסיפו',
        AvailLabels: ' נותרו : ',
        Labels: 'מדבקות ',
        AdminUsers: 'משתמשי מערכת',
        ForCompany: ' עבור חברה: ',
        TicketNumberOrLPR: 'כרטיס כניסה או מספר רכב',
        InsiteOnly: 'בחניון',
        NotDeletedOnly: 'לא מבוטל',
        AttachedLabelsOnly: 'משוייך',
        PaidLabelsOnly: 'שולם',
        UpdatedFrom: 'עדכון מ-',
        UpdatedTo: 'עדכון עד-',
        LabelSetNumber: 'מספר טס',
        Edit: 'עריכה',
        firstname: 'שם פרטי',
        lastname: 'שם משפחה',
        fullname: 'שם',
        guestname: 'שם האורח',
        subscribername: 'שם המנוי',
        division: 'מחלקה',
        PhoneNumber: 'טלפון סלולרי',
        Email: 'מייל',
        AreYouSureDeleteUser: 'משתמש זה ימחק ללא אפשרות שחזור. האם להמשיך?',
        DigitelReport: 'לוג דיגיתל',
        SiteID: 'מספר אתר',
        FilterByDigitel: 'חיפוש לפי דיגיטל',
        timeStamp: 'תאריך',
        multipassID: 'מספר דיגיתל',
        isError: 'שגיאה',
        requestedBenefitCode1: 'קוד 1',
        requestedBenefitCode2: 'קוד 2',
        operationResult: 'תוצאה',
        resultErrorMessage: 'תיאור שגיאה',
        resultCode1: 'קוד זכאות 1',
        resultCode2: 'קוד זכאות 2',
        checkOrigin: 'מקור בדיקה',


        UserActivity: 'פעולות משתמש',
        editDescription: 'תיאור',
        properties: 'פירוט',
        searchNotScan: 'אין לי כרטיס ',
        Search: 'חפש',
        ScanQRCode: 'אני רוצה לסרוק',
        scanBarcode: 'סריקת ברקוד',
        looksLikeWeCouldNotFindCameras: 'נראה שלא מצאנו מצלמה. יש לבדוק הרשאות.',

        attachedLabelsActive: 'הנחה פעילה',
        attachedLabelsActiveDescription: 'מדבקות משויכות פעילות',

        UserWithThisNameExists: 'משתמש עם שם זה כבר קיים.',

        InternalServerError: 'שגיאה כללית',

        CreatedByUserName: 'נוצר ע"י משתמש',
        isMulti: 'מולטי',
        TenantsList: 'לקוחות',
        CreateTenant: 'הקמת לקוח חדש',
        EditTenant: 'עריכת לקוח',

        AreYouSureCancelLabelSet: 'סט זה יבוטל. פעולה זו ניתנת לשיחזור. האם להמשיך?',
        AreYouSureToRestoreLabelSet: 'סט זה ישוחזר. האם להמשיך?',


        Passport: 'מס תעודת זהות',
        GuestsCompany: 'חברה: ',
        constSubscribersCount: 'כמות מנויים שמורים בחניון',
        subscribersCount: 'כמות מנויים רגילים בחניון',
        guestsCount: 'כמות אורחים בחניון',
        available: 'מקומות פנויים',
        reservedPlaces: 'כמות מנויים שמורים',
        Guests: 'אורחים',
        GuestsAppName: 'מערכת ניהול אורחים ומנויים',
        SubscribersAppName: 'מערכת ניהול מנויים',
        Subscribers: 'מנויים',
        IsInSite: 'נמצא בחניון',
        EntranceDate: 'תאריך כניסה ראשית',
        isReserved: 'שמור',
        InvalidformatofCarNumber: 'מספר רכב מכיל ספרות בלבד',
        FirstNameCantbeempty: 'שם פרטי הינו שדה חובה',
        LastNamecantbeempty: 'שם משפחה הינו שדה חובה',
        CarNumbercantbeempty: 'מספר רכב הינו שדה חובה',
        Datecantbeempty: 'תאריך התחלה הינו שדה חובה',
        EndDatecantbeempty: 'תאריך סיום הינו שדה חובה',
        IdentityNumberisarequiredfield: 'מספר תעודת זהות הינו שדה חובה',
        InvalidformatofIdentityNumber: 'מספר תעודת זהות מכיל ספרות בלבד',
        phoneNumberWrongFormat: 'מספר טלפון יכיל ספרות בלבד. אורך השדה הינו 10 תווים',

        NewGuestAction: 'הקמת אורח חדש',
        NewSubscriberAction: 'הקמת מנוי חדש',
        CreateNewGuest: 'אורח חדש',
        CreateNewSubscriber: 'מנוי חדש',

        StartTime: 'שעת התחלה',
        EndTime: 'שעת סיום',
        isReservedPlace: 'מנוי שמור',
        Phone: 'טלפון סלולרי',
        NameOrLastName: 'שם או שם משפחה',
        Parks: 'מתחמים',
        Park: 'מתחם',
        parkDescription: 'תיאור מתחם',

        isPermitted: 'מתחם מורשה',
        isUnlimited: 'מס רכבים אינו מוגבל',

        totalPlacesForCompany: 'סך מקומות לחברה',
        overflowLevel: 'רמת גלישה',
        maxSubsToOverflow: 'מנויים לגלישה',
        parkInsideDescription: 'נמצא ב-',

        usedPlacesByGuests: 'אורחים במתחם',
        usedPlacesByRegularSubscribers: 'מנויים רגילים במתחם',
        usedPlacesByReservedSubscribers: 'מנויים שמורים במתחם',
        totalUsedPlaces: 'סך מקומות תפוסים במתחם',
        freePlacesForRegularSubscribersAndGuests: 'מקומות פנויים למנויים רגילים ואורחים',
        freePlacesForRegularSubscribersAndGuestsAtidim: 'מקומות פנויים למנויים רגילים',
        freePlacesForReservedSubscribers: 'מקומות פנויים למנויים שמורים',

        InSiteOnly: 'הצג מנויים בחניון',
        InSiteGuestsOnly: 'הצג אורחים בחניון',

        DestinedParkCannotBeEmpty: 'מתחם למנוי הינו שדה חובה',
        DestinedPark: 'מתחם מיועד',
        overflowsInPark: 'גולשים',
        SearchByLPRNumberOrName: 'מס רכב או שם',

        DatesInvalid: 'תאריכי התחלה וסיום תוקף אינם תקינים',
        AreUSureDeleteSubscriber: 'המנוי ימחק ללא אפשרות שחזור. האם להמשיך ?',
        AreUSureDeleteSubscriberMobile: 'האם למחוק מנוי ?',
        AreUSureDeleteGuest: 'המבקר ימחק ללא אפשרות שחזור. האם להמשיך ?',
        AreUSureDeleteGuestMobile: 'האם למחוק מבקר ?',

        UnableToCreateMoreSubscribersFprDestinedPark: 'לא ניתן להקים מנויים מעבר לכמות המוגדרת לחניון זה. ',


        SubscribersAmountToCreate: 'סך מנויים להקמה ',
        SubscribersAmountLeftToCreate: 'נותרו להקמה  ',
        SubscribersAmount: 'כמות מנויים: ',
        reservedPark:'שמור בחניון',

        ImportGuests: 'יבוא אורחים',
        ImportFile: 'יבוא מקובץ',
        ToExportExampleFile: 'קובץ לדוגמא',
        ClickHere: 'לחץ כאן',
        SuccessfullyImported: 'יבוא אורחים הסתיים בהצלחה',
        Total: 'הוקמו',
        ParseErrors: 'נכשלו עקב שגיאות באקסל',
        Errors: 'נכשלו עקב שגיאות לוגיות',
        AddCompaniesToUser: 'הוספת חברות למשתמש',
        editPermissions: 'הרשאות עריכה',
        visibilityPermissions: 'הרשאות מנויים \ אורחים',
        companyName: 'שם חברה',
        PasswordMustBe8CLong: 'יש לבחור סיסמה חזקה: הסיסמה צריכה לכלול שמונה תווים בשילוב אותיות קטנות, אותיות גדולות, ספרות וסימנים מיוחדים'

      },
    },
    eng: {
      languange: 'eng',
      values: {
        example: 'Example',
        username: 'User Name',
        Password: 'Password',
        loginUser: 'Log in',
        The_username_or_password_is_incorrect: 'The username or password is incorrect',
        virtualLabelsApp: 'Virtual Labels App',
        Name: 'Name',
        StartDate: 'Start Date',
        EndDate: 'End Date',
        ActiveLabelsSets: 'Active Labels Sets',
        Users: 'Users',
        LabelsSets: 'Labels Sets',
        CompaniesList: 'Companies List',
        FilterByName: 'Filter By Name',
        Loading: 'Loading...',
        FilterByComments: 'Filter By Comments',
        ID: '#',
        Active: 'Active',
        ProfileName: 'Profile Name',
        CreatedDate: 'Created Date',
        LastUpdate: 'Last Update',
        Comments: 'Comments',
        TotalLabels: 'Total Labels',
        UsedLabels: 'Used Labels',
        Cancel: 'Cancel',
        AttachLabel: 'Attach Label',
        Set: 'Set',
        Tickets: 'Tickets',
        Attach: 'Attach',
        Thanks: 'Thanks!',
        LabelAttached: 'Label Attached',
        Date: 'Date',
        LPRNumber: 'LPR Number',
       
        OK: 'OK',
        Continue: 'Continue',
        Thisticketisvirtuallabeled: 'This ticket is virtual labeled',
        Noavaillabelsfoundforthelabelset: 'No avail labels found for the label set',
        Labelsetisnotvalid: 'Label set is not valid',
        Companyisnotvalid: 'Company is not valid',
        CreateUser: 'Create User',
        Role: 'Role',
        Delete: 'Delete',
        CreateLabelSet: 'Create Label Set',
        NewUser: 'New User',
        EditUser: 'Edit User',
        CreateLabelsSetFor: 'Create labels set for ',
        AreYouSure: 'Are You Sure?',
        LabelProfile: 'Label Profile',
        LabelsAmount: 'Labels Amount',
        TicketNumber: 'Ticket Number',
        LabelsReport: 'Labels Report',
        SetComments: 'Set Comments',
        SetID: 'Set ID',
        CompanyName: 'Company Name',
        CreatedByUser: 'Created By User',
        Deleted: 'Deleted',
        Attached: 'Attached',
        AttachedByUser: 'Attached By User',
        EntryTicketIssueDate: 'Entry Ticket Issue Date',
        PaymentDate: 'Payment Date',
        ExitDate: 'Exit Date',
        PaidSum: 'Paid Sum',
        FullPriceBeforeBenefit: 'Full Price Before Benefit',
        BenefitSum: 'Benefit Sum',
        Companies: 'Companies',
        LogOut: 'LogOut',
        Management: 'Management',
        SystemConfiguration: 'System Configuration',
        Sites: 'Sites',
        EntryTicket: 'Entry Ticket',
        GotIt: 'Got It',
        Billing: 'Billing',
        Notifications: 'Notifications',
        Address: 'Address',
        IpAddress: 'Ip Address',
        Center: 'Center',
        NoLabelsToAttach: 'No Labels To Attach',
        SearchAgain: 'Search Again',
        TicketNotFound: 'Could not found tickets',
        Restore: 'Restore',
        requestNewFeature: 'Request New Feature',
        AvailLabels: 'Avail : ',
        Labels: ' Labels ',
        AdminUsers: 'Admin Users',
        ForCompany: ' For Company: ',
        TicketNumberOrLPR: 'Ticket Number Or LPR',
        InsiteOnly:'In site',
        NotDeletedOnly:'Not Deleted',
        AttachedLabelsOnly:'Attached Labels',
        PaidLabelsOnly:'Paid',
        UpdatedFrom:'Updated From',
        UpdatedTo: 'Updated To',
        LabelSetNumber: 'Label Set Number',
        Edit: 'Edit',
        firstname: 'Name',
        lastname: 'Last Nane',
        division: 'Division',
        PhoneNumber: 'Phone Number',
        Email: 'Email',
        AreYouSureDeleteUser: 'This user will be deleted forever. Are you sure?',

        UserActivity: 'User Activity:',
        editDescription: 'Description',
        properties: 'Properties',
        searchNotScan: 'Or search by ticket number',
        Search: 'Search',
        ScanQRCode: 'Or Scan barcode',
        scanBarcode: 'Scan barcode',
        looksLikeWeCouldNotFindCameras: 'Looks like we could not find cameras. Please check permissions.',
        attachedLabelsActive: 'Attached Labels Active',
        attachedLabelsActiveDescription: 'Attached Labels are active.',

        UserWithThisNameExists: 'User with the same username already exists',

        InternalServerError: 'Internal Server Error',
        CreateTenant: 'Create tenant',
        EditTenant: 'Edit tenant',

        AreYouSureCancelLabelSet: 'Cancel Label Set?',
        AreYouSureToRestoreLabelSet: 'Restore Label Set?',
        
        Passport: 'Passport 1',
        GuestsCompany: 'GuestsCompany: ',
        constSubscribersCount: 'constSubscribersCount',
        subscribersCount: 'subscribersCount',
        guestsCount: 'guestsCount',
        available: 'available',
        reservedPlaces: 'reservedPlaces',
        Ltd: 'Ltd'

      },
    },
  }

  constructor() { }

  translate(key: string): string {
    if (this.dictionary[this.language] != null) {
      //if (key === undefined) console.log('translate key undefined');
      //else console.log('translate for key ' + key);
      if (this.dictionary[this.language].values[key]) {
        return this.dictionary[this.language].values[key]
      }
      else {
        //console.log(`Translate value empty for key ${key}`);
        return key;
      }
    }
   
  }
}

export class TranslationSet1 {
  public languange: string
  public values: { [key: string]: string } = {}
}
